import React from "react";
import ct from "class-types.macro";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import LoginLink from "./LoginLink";
import WhyWeDoThis from "./WhyWeDoThis";
import PlusShippingLevels from "../PlusShippingLevels";
import CreditKeyBanner from "~/ProductDetails/CreditKey/CreditKeyBanner";
const getMAPOversizedPriceClass = (oversizedPrice: number, type: string) => {
  if (["D", "G", "H", "N", "S"].includes(type)) {
    if (oversizedPrice >= 100000) {
      return "price--oversized-mega";
    }
    if (oversizedPrice >= 10000) {
      return "price--oversized";
    }
  }
  return "";
};
interface Props {
  mapPrice: number;
  type: string;
  price: number;
  priceCrossedOut?: boolean;
  showDiscount?: boolean;
  showEnticement?: boolean;
  showLoginLink: boolean;
  showDetails?: boolean;
  showLowerPrice?: boolean;
  hasWebPlusDiscountedShipping?: boolean;
  allowWebPlusDiscountedShipping?: boolean;
  isWebstaurantPlusEligible?: boolean;
  isGoogleView?: boolean;
  hideWhyDoWeDoThis?: boolean;
}
const AddToCartToSeePrice = ({
  mapPrice,
  type,
  price,
  priceCrossedOut,
  showDiscount,
  showEnticement,
  showLoginLink,
  showDetails,
  showLowerPrice,
  hasWebPlusDiscountedShipping = false,
  allowWebPlusDiscountedShipping = false,
  isWebstaurantPlusEligible = false,
  isGoogleView = false,
  hideWhyDoWeDoThis = false
}: Props) => {
  const discount = price - mapPrice;
  const displayHiddenPrice = () => {
    return <>
        {(showDiscount || showLowerPrice) && !isGoogleView && <p className="text__discount">
            {showDiscount ? "Save " : ""}
            <span className="text__highlight">
              {formatAsCurrency.formatIfUndefined(discount)}
            </span>
            {showLowerPrice ? " lower" : ""}
          </p>}
        <p className="text__description">
          {showLoginLink ? <>
              <span className="text__link">Login</span>
              {" or "}
              <strong>add to cart</strong>
            </> : <strong>Add to cart</strong>}
          {" to see our "}
          <span className="text__highlight">price!</span>
        </p>
        {showEnticement && <p className={`text__enticement price ${getMAPOversizedPriceClass(mapPrice, type)}`}>
            {formatAsCurrency.formatIfUndefined(showDiscount && !isGoogleView ? discount : mapPrice).toString().replace(/[0-9]/g, "X")}
          </p>}
      </>;
  };
  return <div className="map map-override map--login" data-sentry-component="AddToCartToSeePrice" data-sentry-source-file="AddToCartToSeePrice.tsx">
      <div className="map__group">
        {showLoginLink ? <LoginLink className={`map__text ${ct("order-1")}`}>
            {displayHiddenPrice()}
          </LoginLink> : <div className={`map__text ${ct("order-1")}`}>
            {displayHiddenPrice()}
          </div>}

        <div className="map__price">
          <label className="price__label">Retail Price </label>
          <p className={`price ${priceCrossedOut ? "price--crossed-out" : ""}`}>
            {formatAsCurrency.formatIfUndefined(price)}
          </p>
        </div>
      </div>
      {!priceCrossedOut && <CreditKeyBanner price={price} style={ct("mt-4")} />}
      {showDetails && <div className="map__details" style={{
      marginTop: "7px"
    }}>
          <PlusShippingLevels hasWebPlusDiscountedShipping={hasWebPlusDiscountedShipping} allowWebPlusDiscountedShipping={allowWebPlusDiscountedShipping} isWebstaurantPlusEligible={isWebstaurantPlusEligible} />
          {!hideWhyDoWeDoThis && <WhyWeDoThis type="cart" />}
        </div>}
    </div>;
};
export default AddToCartToSeePrice;